import store from '@/store/index'

export default () => {
  const authenticateUser = async (to, from, next) => {
    const token = store.getters['users/_userAuthToken']
    const currentUser = store.getters['users/_user']

    if (to.meta.user) {
      // This checks user for route authorization
      if (token && to.meta.user.includes(currentUser?.role)) {
        next()
      } else if (token && to.meta.user !== currentUser.role) {
        // User is unauthorized to enter/view a page, hence redirected to 'NOT FOUND PAGE'
        return next('/not-found')
      } else {
        // unknown user, hence redirected to 'REGISTER PAGE'
        return next('/register')
      }
    } else {
      // unprotected routes, hence can be viewed by any one
      return next()
    }
  }

  return {
    authenticateUser
  }
}
